import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class TableColumnAPI extends ComponentAPI {
    /**
     * Returns the alignment of the column values
     */
    getAligment() {
        return this.state.alignment;
    }
    /**
     * Updates the alignment of the column values
     * @param aligment - The alignment of the column values
     */
    setAligment(aligment) {
        this.setState({ aligment });
    }
    /**
     * Returns the alignment of the column header
     */
    getHeaderAlignment() {
        return this.state.headerAlignment;
    }
    /**
     * Updates the alignment of the column header
     * @param headerAlignment - The alignment of the column header
     */
    setHeaderAlignment(headerAlignment) {
        this.setState({ headerAlignment });
    }
    /**
     * Returns a boolean indicating if the column is resizable
     */
    isResizable() {
        return this.state.resizable;
    }
    /**
     * Sets if the column should be resizable
     * @param resizable - If the column should be resizable
     */
    setResizable(resizable) {
        this.setState({ resizable });
    }
    /**
     * Returns a boolean indicating if the label superscription is visible
     */
    isShowSuperscriptionLabel() {
        return this.state.showSuperscriptionLabel ?? false;
    }
    /**
     * Sets if the label superscription should be visible
     * @param showSuperscriptionLabel - If the label superscription should be visible
     */
    setShowSuperscriptionLabel(showSuperscriptionLabel) {
        this.setState({ showSuperscriptionLabel });
    }
    /**
     * Returns a boolean indicating if the column is sortable
     */
    isSortable() {
        return this.state.sortable;
    }
    /**
     * Sets if the column should be sortable
     * @param sortable - If the column should be sortable
     */
    setSortable(sortable) {
        this.setState({ sortable });
    }
    /**
     * Returns the sort direction of the column
     */
    getSortDirection() {
        return this.state.sortDirection;
    }
    /**
     * Updates the sort direction of the column
     * @param sortDirection - The sort direction of the column
     */
    setSortDirection(sortDirection) {
        this.setState({ sortDirection });
    }
    /**
     * Returns the superscription of the column label
     */
    getSuperscription() {
        return this.state.superscription ?? [];
    }
    /**
     * Updates the superscription of the column label
     * @param superscription - The superscription of the column label
     */
    setSuperscription(superscription) {
        if (Array.isArray(superscription)) {
            this.setState({ superscription });
        }
    }
    /**
     * Returns the type of the column
     */
    getType() {
        return this.state.type;
    }
    /**
     * Updates the type of the column
     * @param type - The type of the column
     */
    setType(type) {
        this.setState({ type });
    }
    /**
     * Returns the value of the column
     */
    getValue() {
        return this.state.value;
    }
    /**
     * Updates the value of the column
     * @param value - The column value
     */
    setValue(value) {
        this.setState({ value });
    }
    /**
     * Returns a boolean indicating if the column is visible
     */
    isVisible() {
        return this.state.visible;
    }
    /**
     * Sets if the column should be visible
     * @param visible - If the column should be visible
     */
    setVisible(visible) {
        this.setState({ visible });
    }
    /**
     * Returns the width of the column
     */
    getWidth() {
        return this.state.width;
    }
    /**
     * Updates the width of the column
     * @param width - The width value
     */
    setWidth(width) {
        if (width < 0) {
            throw Error('[TableColumnAPI]: Invalid width');
        }
        this.setState({ width });
    }
    /**
     * Returns the entry used by the column
     */
    getEntry() {
        return this.state.entry;
    }
    /**
     * Updates the entry used by the column
     * @param entry - The entry value
     */
    setEntry(entry) {
        this.setState({ entry });
    }
}
export default TableColumnAPI;
//# sourceMappingURL=table-column-api.js.map